import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import { businessInfo } from '../data/mockData';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-burgundy-950 to-black text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img 
              src={businessInfo.logo}
              alt={businessInfo.name}
              className="h-32 w-auto mb-8"
            />
            <p className="text-orange-200/80 mb-6 leading-relaxed max-w-md text-lg">
              Bringing authentic Indian street food to your events and celebrations. Fresh, flavorful, and unforgettable experiences, one dish at a time.
            </p>
            <div className="flex space-x-4">
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 hover:bg-gradient-to-br hover:from-orange-500 hover:to-yellow-500 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 hover:bg-gradient-to-br hover:from-orange-500 hover:to-yellow-500 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 hover:bg-gradient-to-br hover:from-orange-500 hover:to-yellow-500 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-orange-300">Quick Links</h3>
            <ul className="space-y-3">
              {['Home', 'About', 'Menu', 'Services', 'Gallery', 'Testimonials', 'Contact'].map((link) => (
                <li key={link}>
                  <button
                    onClick={() => scrollToSection(link.toLowerCase())}
                    className="text-orange-200/80 hover:text-orange-400 transition-colors"
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-orange-300">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="text-orange-400 flex-shrink-0 mt-1" size={18} />
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="text-orange-200/80 hover:text-orange-400 transition-colors text-sm"
                >
                  {businessInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="text-orange-400 flex-shrink-0 mt-1" size={18} />
                <span className="text-orange-200/80 text-sm">{businessInfo.phone}</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="text-orange-400 flex-shrink-0 mt-1" size={18} />
                <span className="text-orange-200/80 text-sm">Mobile Service • Events Across the Region</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-orange-900/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-orange-200/60 text-sm">
              © {currentYear} {businessInfo.name}. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-orange-200/60 hover:text-orange-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-orange-200/60 hover:text-orange-400 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
